import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { AbstractComponent, FieldTextComponent, FieldDateComponent, FieldNumberComponent } from '@spike/scaffolds';
import { FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { EntityModelField } from 'src/app/features/configuration/models/entity-model-field.model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-model-dynamic-form',
  providers:[],
  imports: [FormsModule, ReactiveFormsModule, FieldTextComponent, FieldDateComponent, FieldNumberComponent],
  templateUrl: './model-dynamic-form.html'
})
export class ModelDynamicFormComponent extends AbstractComponent{
  form = input.required<FormGroup>();

  //input
  entityModelFields = input.required<EntityModelField[]>();

}

    